import { useContext } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'

const useForm = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (context === undefined) {
        throw new Error('useForm must be used within a Scenario States Provider')
    }

    const { formData, setFormData, scenarioJson, setScenarioJson, simulatorList, setSimulatorList, selectedSimulator, setSelectedSimulator } = context
    return { formData, setFormData, scenarioJson, setScenarioJson, simulatorList, setSimulatorList, selectedSimulator, setSelectedSimulator }
}

export default useForm